import { Accordion, AccordionItem } from '@nextui-org/react'

export const UxAccordion = ({
    title,
    itemKey,
    defaultExpandedKeys,
    children,
}) => {
    return (
        <Accordion
            className="px-0"
            defaultExpandedKeys={defaultExpandedKeys}
            disableAnimation={false}
            disableIndicatorAnimation={false}
            hideIndicator={false}
            isCompact={false}
            isDisabled={false}
        >
            <AccordionItem
                title={title}
                classNames={{
                    trigger:
                        'px-4 py-2 my-1 rounded-lg dark:bg-zinc-800 bg-zinc-200 font-semibold',
                }}
                key={itemKey}
            >
                {children}
            </AccordionItem>
        </Accordion>
    )
}
